import React from "react";
import { useTranslation } from "react-i18next";
import InputTextControl from "~/components/InputTextControl";
import styled from "styled-components";
const StyledInputTextControl = styled(InputTextControl)`
  font-size: 2rem;
`;
const SlackVerificationCodeForm = _ref => {
  let {
    control
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement(StyledInputTextControl, {
    name: "code",
    placeholder: t("SlackVerificationCodeForm.sixDigits"),
    control: control
  }));
};
export default SlackVerificationCodeForm;